import { Button, Td, Tr } from '@chakra-ui/react'
import { Dispatch, SetStateAction } from 'react'
import moment from 'moment'
import { Regimen } from '../../types/Regimen'

interface DentalProcedureRowProps {
  record: Regimen
  lists: {
    label: string
    fieldId: string
    items: { [itemId: string]: string }
    id: string
  }[]
  month: string
  year: string
  setEditingId: Dispatch<SetStateAction<string | undefined>>
  setStartDate: Dispatch<SetStateAction<string>>
  modal: { onOpen: () => void }
}

export default function DentalProcedureRow({
  record,
  lists,
  month,
  year,
  setEditingId,
  setStartDate,
  modal,
}: DentalProcedureRowProps) {
  // For dental procedures, show only one row (using the latest usage)
  const lastUsage = record.usages[record.usages.length - 1]

  const handleUpdate = () => {
    setEditingId(record.id)
    setStartDate(lastUsage.startDate)
    modal.onOpen()
  }

  return (
    <Tr>
      <Td>
        <Button size="sm" onClick={handleUpdate}>
          Update
        </Button>
      </Td>
      <Td>
        {lastUsage.startDate
          ? moment(lastUsage.startDate, 'YYYY-MM-DD').format('YYYY-MM-DD')
          : `Before ${month}/${year}`}
      </Td>
      <Td>{lists[0].items[lastUsage.fields[lists[0].fieldId]]}</Td>
    </Tr>
  )
}
